import React from 'react'
import Box from '@mui/material/Box'
import { Alert } from '@mui/material'
import TooltipPopover from '@/components/shared/others/TooltipPopover'

type Props = {
  message: string
  tooltipContent: React.ReactNode
}

const AlertWithTooltip: React.FC<Props> = ({ message, tooltipContent }) => (
  <Alert variant='standard' severity='info'>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
      {message}
      <Box sx={{ mb: '-5px', '& .MuiIconButton-root': { color: 'inherit' } }}>
        <TooltipPopover>
          {tooltipContent}
        </TooltipPopover>
      </Box>
    </Box>
  </Alert>
)

export default AlertWithTooltip
